import { COLORS } from 'styles';

export interface SideBarIconProps {
  icon: 'home' | 'trophy' | 'account';
  color: 'filled' | 'inherit';
}

const icons: Record<SideBarIconProps['icon'], (p: SideBarIconProps) => JSX.Element> = {
  home: ({ color }) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M11.0047 5.57053L2.10254 13.8047V19.4858C2.10254 20.5438 3.00223 21.4178 4.09132 21.4178H8.44771V13.8047H13.5381V21.4178H17.8944C18.9835 21.4178 19.8832 20.5438 19.8832 19.4858V13.8047L11.0047 5.57053Z"
        fill={color === 'inherit' ? 'currentColor' : COLORS.primary.DEFAULT}
      />
      <path
        d="M9.63108 1.517L1.41551 9.13015C0.610527 9.88917 0.586851 11.1312 1.39184 11.8902L11.0043 2.98903L20.6167 11.8902C21.3981 11.1312 21.3981 9.86617 20.5931 9.13015L12.3775 1.517C11.5962 0.803981 10.3887 0.803981 9.63108 1.517Z"
        fill={color === 'inherit' ? 'currentColor' : COLORS.foreground.title}
      />
      <path
        d="M18.2258 5.58892V2.46087C18.2258 1.63285 17.5392 0.988838 16.7106 0.988838C15.8582 0.988838 15.1953 1.65585 15.1953 2.46087V2.75987L18.2258 5.58892Z"
        fill={color === 'inherit' ? 'currentColor' : COLORS.primary.DEFAULT}
      />
    </svg>
  ),

  trophy: ({ color }) => (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none">
      <path
        d="M15.3689 18.5819H6.10645V20.46H15.3689V18.5819Z"
        fill={color === 'inherit' ? 'currentColor' : '#fcc112'}
      />
      <path
        d="M20.9262 3.55714V8.25238C20.9262 8.39324 20.8798 8.53409 20.8335 8.67495L19.9073 10.553L18.2401 9.7079L19.0737 8.01762V4.49619H17.2212V8.20543C17.2212 11.539 14.813 14.3092 11.6637 14.7788V16.7038H13.5162V17.6429H7.95877V16.7038H9.81125V14.7318C6.66203 14.2623 4.2538 11.4921 4.2538 8.15847V4.49619H2.40131V8.01762L3.23493 9.7079L1.56769 10.553L0.641452 8.67495L0.687764 8.628C0.548828 8.01762 0.548828 6.60905 0.548828 3.55714C0.548828 3.04066 0.965637 2.61809 1.47507 2.61809H4.2538V1.67905C4.2538 1.16257 4.67061 0.739998 5.18004 0.739998H16.2949C16.8044 0.739998 17.2212 1.16257 17.2212 1.67905V2.61809H19.9999C20.5094 2.61809 20.9262 3.04066 20.9262 3.55714Z"
        fill={color === 'inherit' ? 'currentColor' : '#fde148'}
      />
      <path
        d="M8.98894 5.65863H7.11084L10.4646 10.26L13.6842 5.65863H11.9402L10.4646 7.65921L8.98894 5.65863Z"
        fill={color === 'inherit' ? COLORS.primary.DEFAULT : '#fcc112'}
      />
      <path
        d="M1.55646 10.2131L0.630222 8.33499L0.676534 8.28804C0.537598 7.67766 0.537598 6.26909 0.537598 3.21718C0.537598 2.70071 0.954407 2.27814 1.46384 2.27814H4.24257V4.15623H2.39008C2.39008 5.28309 2.39008 7.06728 2.39008 7.67766L3.2237 9.36795L1.55646 10.2131Z"
        fill={color === 'inherit' ? 'currentColor' : '#fcc112'}
      />
      <path
        d="M19.8966 10.2131L18.2293 9.36795L19.0629 7.67766V4.15623H17.2104V2.27814H19.9892C20.4986 2.27814 20.9154 2.70071 20.9154 3.21718V7.91242C20.9154 8.05328 20.8691 8.19414 20.8228 8.33499L19.8966 10.2131Z"
        fill={color === 'inherit' ? 'currentColor' : '#fcc112'}
      />
    </svg>
  ),

  account: ({ color }) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M0.591797 15.9992C0.591797 13.6459 2.49947 11.7383 4.8527 11.7383H12.2632C13.2949 11.7383 13.8686 12.8385 13.2702 13.6789C12.8616 14.2528 12.5245 14.7945 12.3326 15.4245C12.0079 16.49 12.1747 17.886 12.3326 19.3206H0.591797V15.9992Z"
        fill={color === 'inherit' ? 'currentColor' : '#ec5d8a'}
      />

      <circle
        cx="8.20035"
        cy="5.06139"
        r="4.2609"
        fill={color === 'inherit' ? 'currentColor' : '#ec5d8a'}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5123 14.9051H18.3409V13.9642C18.3409 13.4593 17.9316 13.0499 17.4266 13.0499C16.9217 13.0499 16.5123 13.4593 16.5123 13.9642V14.9051ZM15.2013 14.9051H14.4286C13.8855 14.9051 13.4453 15.3454 13.4453 15.8884V20.2162C13.4453 20.7593 13.8855 21.1995 14.4286 21.1995H20.424C20.9671 21.1995 21.4073 20.7593 21.4073 20.2162V15.8884C21.4073 15.3454 20.9671 14.9051 20.424 14.9051H19.652V13.9642C19.652 12.7352 18.6556 11.7389 17.4266 11.7389C16.1976 11.7389 15.2013 12.7352 15.2013 13.9642V14.9051Z"
        fill={color === 'inherit' ? 'currentColor' : '#ec5d8a'}
      />
    </svg>
  ),
};

export function SideBarIcon(props: SideBarIconProps) {
  const Icon = icons[props.icon];

  return <Icon {...props} />;
}
